export const SLIDER_PADDING = 80;
